import { comparable, nutritionAdherence, trainingAdherence, validPeriod, failure } from '../domain/progress.ts';
import type { Period, PerformanceFact } from '../domain/progress.ts';
import { nutritionTotals } from '../domain/progress-nutrition.ts';
import type { TrainingProgressSource, NutritionProgressSource } from '../ports/progress-sources.ts';
export class ProgressMetrics {
  constructor(private training: TrainingProgressSource, private nutrition: NutritionProgressSource) {}
  async getPerformanceHistory(exerciseId?: string) {
    const facts = await this.training.readTrainingFacts();
    return facts.ok ? { ok:true as const, value:facts.value.performance.filter(f=>!exerciseId||f.context.exerciseId===exerciseId) } : facts;
  }
  comparable(a: PerformanceFact, b: PerformanceFact) { return comparable(a,b); }
  async getTrainingAdherence(period: Period) {
    if (!validPeriod(period)) return failure('VALIDATION_ERROR');
    const facts = await this.training.readTrainingFacts();
    return facts.ok ? trainingAdherence(facts.value.sessions,period) : facts;
  }
  async getNutritionAdherence(period: Period) {
    if (!validPeriod(period)) return failure('VALIDATION_ERROR');
    const facts = await this.nutrition.readNutritionFacts(period);
    return facts.ok ? nutritionAdherence(facts.value.resolutions,facts.value.actual.filter(c=>!c.plannedMealId).map(c=>c.localDate),period) : facts;
  }
  async getNutritionTotals(period: Period) {
    if (!validPeriod(period)) return failure('VALIDATION_ERROR');
    const facts = await this.nutrition.readNutritionFacts(period); if (!facts.ok) return facts;
    const entries = facts.value.quantitative.map(fact => fact.entry);
    const quantitativeConsumptionIds = new Set(facts.value.quantitative.map(fact => fact.consumptionId));
    const unquantifiedRealizedCount = facts.value.actual.filter(consumption =>
      consumption.resolution === 'REALIZADA' && !quantitativeConsumptionIds.has(consumption.consumptionId)).length;
    const result = nutritionTotals(entries, unquantifiedRealizedCount);
    return { ok:true as const, value:{ ...result, period,
      reason: result.coverage === 'COMPLETA' ? null
        : result.coverage === 'PARCIAL' ? 'Existen subtotales válidos, pero falta información necesaria.'
          : 'No existe subtotal cuantitativo útil con composición histórica suficiente.' } };
  }
}
